<div class="space-y-6 pb-6">
  <!-- ── Header ──
  <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
    <div>
      <h1 class="text-2xl font-bold text-gray-900 dark:text-gray-100">
        {{ 'DASHBOARD.TITLE' | translate }}
      </h1>
      <p class="text-sm text-gray-500 dark:text-gray-400 mt-0.5">
        {{ 'DASHBOARD.SUBTITLE' | translate }}
      </p>
    </div>
    <div class="flex items-center gap-3 self-start sm:self-auto">
      <div
        class="flex items-center gap-2 text-xs text-gray-500 dark:text-gray-400 bg-gray-100 dark:bg-gray-800 px-3 py-1.5 rounded-full"
      >
        <p-toggleswitch [(ngModel)]="autoRefreshModel" />
        <span>{{ 'DASHBOARD.CONTROLS.AUTO_REFRESH' | translate }}</span>
      </div>
      <p-button
        [label]="'DASHBOARD.CONTROLS.EXPORT' | translate"
        icon="pi pi-download"
        severity="secondary"
        [outlined]="true"
        size="small"
        (onClick)="exportCsv()"
      />
    </div>
  </div> -->

  <!-- ── Filters ── -->
  <div
    class="rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 p-4 shadow-sm"
  >
    <div class="grid grid-cols-2 lg:grid-cols-5 gap-3">
      <div class="flex flex-col gap-1">
        <span class="text-xs font-medium text-gray-500 dark:text-gray-400">{{
          'DASHBOARD.FILTER.FROM' | translate
        }}</span>
        <p-datepicker
          [(ngModel)]="filterFrom"
          dateFormat="dd.mm.yy"
          [showIcon]="true"
          [iconDisplay]="'input'"
          [placeholder]="'DASHBOARD.FILTER.START' | translate"
          styleClass="w-full"
          inputStyleClass="text-sm"
        />
      </div>

      <div class="flex flex-col gap-1">
        <span class="text-xs font-medium text-gray-500 dark:text-gray-400">{{
          'DASHBOARD.FILTER.TO' | translate
        }}</span>
        <p-datepicker
          [(ngModel)]="filterTo"
          dateFormat="dd.mm.yy"
          [showIcon]="true"
          [iconDisplay]="'input'"
          [placeholder]="'DASHBOARD.FILTER.END' | translate"
          styleClass="w-full"
          inputStyleClass="text-sm"
        />
      </div>

      <!-- Bitta do'konda filtr yashiriladi: "hammasi" bilan bir xil natija beradi. -->
      @if (storePick.visible()) {
        <div class="flex flex-col gap-1 col-span-2 lg:col-span-1">
          <span class="text-xs font-medium text-gray-500 dark:text-gray-400">{{
            'DASHBOARD.FILTER.STORE' | translate
          }}</span>
          <p-multiselect
            [(ngModel)]="selectedStoreIds"
            [options]="stores()"
            optionLabel="name"
            optionValue="id"
            [placeholder]="'DASHBOARD.FILTER.ALL_STORES' | translate"
            styleClass="w-full"
            display="chip"
            appendTo="body"
          />
        </div>
      }

      <!--
        Valyuta filtri. Dashboarddagi barcha raqamlar BITTA valyutada bo'lishi shart —
        turli valyutadagi summalarni qo'shib bo'lmaydi. Bitta valyuta bo'lsa
        tanlagich ko'rsatilmaydi (ekran o'zgarmaydi).
      -->
      @if (stats().availableCurrencies.length > 1) {
        <div class="flex flex-col gap-1 col-span-2 lg:col-span-1">
          <label for="dash-currency" class="text-xs font-medium text-gray-500 dark:text-gray-400">
            {{ 'DASHBOARD.FILTER.CURRENCY' | translate }}
          </label>
          <p-select
            inputId="dash-currency"
            [options]="stats().availableCurrencies"
            [ngModel]="selectedCurrency()"
            (ngModelChange)="onCurrencyChange($event)"
            appendTo="body"
            class="w-full"
          />
        </div>
      }

      <div class="col-span-2 lg:col-span-1 flex gap-2 items-end">
        <p-button
          class="flex-1"
          styleClass="w-full"
          [label]="'DASHBOARD.FILTER.APPLY' | translate"
          icon="pi pi-search"
          (onClick)="loadData()"
          [loading]="loading()"
        />
        <p-button
          [label]="'DASHBOARD.FILTER.RESET' | translate"
          icon="pi pi-refresh"
          severity="secondary"
          [outlined]="true"
          (onClick)="resetFilter()"
        />
      </div>
    </div>
  </div>

  <!--
    Valyuta taqsimoti. Bu yerda JAMLANGAN bitta son ataylab YO'Q — turli valyutadagi
    foydani qo'shib bo'lmaydi. Har daftar o'z qatorida ko'rsatiladi.
  -->
  @if (stats().salesByCurrency.length > 1) {
    <div
      class="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-4"
    >
      <div class="text-sm font-medium text-gray-500 dark:text-gray-400 mb-3">
        {{ 'DASHBOARD.BY_CURRENCY' | translate }}
      </div>
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        @for (row of stats().salesByCurrency; track row.currency) {
          <button
            type="button"
            (click)="onCurrencyChange(row.currency)"
            class="text-left rounded-lg border p-3 transition-colors"
            [class.border-emerald-300]="selectedCurrency() === row.currency"
            [class.dark:border-emerald-800]="selectedCurrency() === row.currency"
            [class.bg-emerald-50]="selectedCurrency() === row.currency"
            [class.dark:bg-emerald-950]="selectedCurrency() === row.currency"
            [class.border-gray-200]="selectedCurrency() !== row.currency"
            [class.dark:border-gray-700]="selectedCurrency() !== row.currency"
          >
            <div class="text-xs font-semibold text-gray-500 dark:text-gray-400">
              {{ row.currency }}
            </div>
            <div class="mt-1 text-lg font-bold text-gray-900 dark:text-gray-100">
              {{ row.amount | moneyFixed: row.currency }}
            </div>
            <div class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
              {{ 'DASHBOARD.KPI.GROSS_PROFIT' | translate }}:
              {{ profitFor(row.currency) | moneyFixed: row.currency }}
            </div>
          </button>
        }
      </div>
    </div>
  }

  @if (!loading() && (stats().lowStockAlerts.length > 0 || stats().totalOutstandingDebt > 0)) {
    <div
      class="rounded-xl border border-amber-200 dark:border-amber-900/50 bg-amber-50/80 dark:bg-amber-950/30 p-4 space-y-2"
    >
      @if (stats().lowStockAlerts.length > 0) {
        <p class="text-sm font-medium text-amber-900 dark:text-amber-100">
          {{ 'DASHBOARD.ALERTS.LOW_STOCK' | translate: { count: stats().lowStockAlerts.length } }}
        </p>
      }
      @if (stats().totalOutstandingDebt > 0) {
        <p class="text-sm font-medium text-amber-900 dark:text-amber-100">
          {{
            'DASHBOARD.ALERTS.DEBT'
              | translate
                : {
                    count: stats().debtOrderCount,
                    amount: fmt(stats().totalOutstandingDebt),
                  }
          }}
        </p>
      }
    </div>
  }

  <!-- ── KPI Cards ── -->
  @if (loading()) {
    <div class="grid gap-4 grid-cols-2 lg:grid-cols-4">
      @for (_ of [1, 2, 3, 4]; track $index) {
        <div
          class="rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 p-5 shadow-sm"
        >
          <p-skeleton height="0.75rem" styleClass="mb-3 w-1/2" />
          <p-skeleton height="2rem" styleClass="mb-2 w-3/4" />
          <p-skeleton height="0.65rem" styleClass="w-2/3" />
        </div>
      }
    </div>
  } @else {
    <div class="grid gap-4 grid-cols-2 lg:grid-cols-4">
      <!-- Total sales -->
      <div
        class="rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 p-3 sm:p-5 shadow-sm hover:shadow-md transition-shadow"
      >
        <div class="flex items-start justify-between">
          <div class="flex-1 min-w-0">
            <p
              class="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide"
            >
              {{ 'DASHBOARD.KPI.TOTAL_SALES' | translate }}
            </p>
            <p
              class="text-lg sm:text-2xl font-bold text-gray-900 dark:text-gray-100 mt-1 truncate tabular-nums"
            >
              {{ fmtM(stats().totalSales) }}
              <span class="text-sm font-normal text-gray-500">{{ currencySymbol() }}</span>
            </p>
            <div class="flex items-center gap-2 mt-1">
              <p class="text-xs text-emerald-600 font-medium">
                {{ 'DASHBOARD.KPI.TODAY_SALES' | translate: { amount: fmtM(stats().todaySales) } }}
              </p>
              @if (salesDelta(); as d) {
                <span
                  class="text-xs font-semibold inline-flex items-center gap-0.5"
                  [class.text-emerald-600]="d.dir === 'up'"
                  [class.text-red-600]="d.dir === 'down'"
                  [class.text-gray-400]="d.dir === 'flat'"
                  [pTooltip]="'DASHBOARD.COMPARE.VS_PREV' | translate"
                >
                  <i
                    class="pi text-[10px]"
                    [class.pi-arrow-up]="d.dir === 'up'"
                    [class.pi-arrow-down]="d.dir === 'down'"
                    [class.pi-minus]="d.dir === 'flat'"
                  ></i>
                  {{ d.pct | number: '1.0-1' }}%
                </span>
              }
            </div>
          </div>
          <div
            class="w-10 h-10 rounded-lg bg-green-50 dark:bg-green-900/30 flex items-center justify-center shrink-0 ml-3"
          >
            <i class="pi pi-dollar text-green-600 dark:text-green-400 text-lg"></i>
          </div>
        </div>
      </div>

      <!-- Orders -->
      <div
        class="rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 p-3 sm:p-5 shadow-sm hover:shadow-md transition-shadow"
      >
        <div class="flex items-start justify-between">
          <div class="flex-1 min-w-0">
            <p
              class="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide"
            >
              {{ 'DASHBOARD.KPI.ORDERS' | translate }}
            </p>
            <p
              class="text-lg sm:text-2xl font-bold text-gray-900 dark:text-gray-100 mt-1 tabular-nums"
            >
              {{ fmt(stats().totalOrders) }}
            </p>
            <div class="flex items-center gap-2 mt-1">
              <p class="text-xs text-emerald-600 font-medium">
                {{ 'DASHBOARD.KPI.TODAY_ORDERS' | translate: { count: stats().todayOrders } }}
              </p>
              @if (ordersDelta(); as d) {
                <span
                  class="text-xs font-semibold inline-flex items-center gap-0.5"
                  [class.text-emerald-600]="d.dir === 'up'"
                  [class.text-red-600]="d.dir === 'down'"
                  [class.text-gray-400]="d.dir === 'flat'"
                  [pTooltip]="'DASHBOARD.COMPARE.VS_PREV' | translate"
                >
                  <i
                    class="pi text-[10px]"
                    [class.pi-arrow-up]="d.dir === 'up'"
                    [class.pi-arrow-down]="d.dir === 'down'"
                    [class.pi-minus]="d.dir === 'flat'"
                  ></i>
                  {{ d.pct | number: '1.0-1' }}%
                </span>
              }
            </div>
          </div>
          <div
            class="w-10 h-10 rounded-lg bg-green-50 dark:bg-green-900/30 flex items-center justify-center shrink-0 ml-3"
          >
            <i class="pi pi-shopping-cart text-green-600 dark:text-green-400 text-lg"></i>
          </div>
        </div>
      </div>

      <!-- Profit -->
      <div
        class="rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 p-3 sm:p-5 shadow-sm hover:shadow-md transition-shadow"
      >
        <div class="flex items-start justify-between">
          <div class="flex-1 min-w-0">
            <p
              class="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide"
            >
              {{ 'DASHBOARD.KPI.PROFIT' | translate }}
            </p>
            <p
              class="text-lg sm:text-2xl font-bold mt-1 truncate tabular-nums"
              [class.text-emerald-600]="stats().totalProfit >= 0"
              [class.text-red-600]="stats().totalProfit < 0"
            >
              {{ fmtM(stats().totalProfit) }}
              <span class="text-sm font-normal text-gray-500">{{ currencySymbol() }}</span>
            </p>
            <div class="flex items-center gap-2 mt-1">
              <p class="text-xs text-gray-400 dark:text-gray-500">
                {{
                  'DASHBOARD.KPI.MARGIN' | translate: { value: (profitMargin() | number: '1.1-1') }
                }}
              </p>
              @if (profitDelta(); as d) {
                <span
                  class="text-xs font-semibold inline-flex items-center gap-0.5"
                  [class.text-emerald-600]="d.dir === 'up'"
                  [class.text-red-600]="d.dir === 'down'"
                  [class.text-gray-400]="d.dir === 'flat'"
                  [pTooltip]="'DASHBOARD.COMPARE.VS_PREV' | translate"
                >
                  <i
                    class="pi text-[10px]"
                    [class.pi-arrow-up]="d.dir === 'up'"
                    [class.pi-arrow-down]="d.dir === 'down'"
                    [class.pi-minus]="d.dir === 'flat'"
                  ></i>
                  {{ d.pct | number: '1.0-1' }}%
                </span>
              }
            </div>
          </div>
          <div
            class="w-10 h-10 rounded-lg bg-emerald-50 dark:bg-emerald-900/30 flex items-center justify-center shrink-0 ml-3"
          >
            <i class="pi pi-chart-line text-emerald-600 dark:text-emerald-400 text-lg"></i>
          </div>
        </div>
      </div>

      <!-- Avg order -->
      <div
        class="rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 p-3 sm:p-5 shadow-sm hover:shadow-md transition-shadow"
      >
        <div class="flex items-start justify-between">
          <div class="flex-1 min-w-0">
            <p
              class="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide"
            >
              {{ 'DASHBOARD.KPI.AVG_ORDER' | translate }}
            </p>
            <p
              class="text-lg sm:text-2xl font-bold text-gray-900 dark:text-gray-100 mt-1 truncate tabular-nums"
            >
              {{ fmtM(avgOrderValue()) }}
              <span class="text-sm font-normal text-gray-500">{{ currencySymbol() }}</span>
            </p>
            <p
              class="text-xs mt-1 font-medium"
              [class.text-amber-600]="stats().debtOrderCount > 0"
              [class.text-gray-400]="stats().debtOrderCount === 0"
            >
              {{ 'DASHBOARD.KPI.DEBT_ORDERS' | translate: { count: stats().debtOrderCount } }}
            </p>
          </div>
          <div
            class="w-10 h-10 rounded-lg bg-amber-50 dark:bg-amber-900/30 flex items-center justify-center shrink-0 ml-3"
          >
            <i class="pi pi-receipt text-amber-600 dark:text-amber-400 text-lg"></i>
          </div>
        </div>
      </div>
    </div>
  }

  <!-- ── Financial result (ERP aniqlik): Sof foyda = Yalpi − Xarajat − Chiqim ── -->
  @if (!loading() && statStatus() === 'ok') {
    <div class="grid gap-4 grid-cols-2 lg:grid-cols-4">
      <!-- Net profit -->
      <div
        class="rounded-xl border-2 p-3 sm:p-5 shadow-sm"
        [class.border-emerald-300]="stats().netProfit >= 0"
        [class.bg-emerald-50/50]="stats().netProfit >= 0"
        [class.dark:border-emerald-800]="stats().netProfit >= 0"
        [class.border-red-300]="stats().netProfit < 0"
        [class.bg-red-50/50]="stats().netProfit < 0"
        [class.dark:border-red-900]="stats().netProfit < 0"
      >
        <div class="flex items-start justify-between">
          <div class="flex-1 min-w-0">
            <p
              class="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide"
            >
              {{ 'DASHBOARD.KPI.NET_PROFIT' | translate }}
            </p>
            <p
              class="text-lg sm:text-2xl font-bold mt-1 truncate tabular-nums"
              [class.text-emerald-600]="stats().netProfit >= 0"
              [class.text-red-600]="stats().netProfit < 0"
            >
              {{ fmtM(stats().netProfit) }}
              <span class="text-sm font-normal text-gray-500">{{ currencySymbol() }}</span>
            </p>
            <div class="flex items-center gap-2 mt-1">
              <p class="text-xs text-gray-400 dark:text-gray-500">
                {{ 'DASHBOARD.KPI.GROSS_PROFIT' | translate }}: {{ fmtM(stats().totalProfit) }}
              </p>
              @if (netProfitDelta(); as d) {
                <span
                  class="text-xs font-semibold inline-flex items-center gap-0.5"
                  [class.text-emerald-600]="d.dir === 'up'"
                  [class.text-red-600]="d.dir === 'down'"
                  [class.text-gray-400]="d.dir === 'flat'"
                  [pTooltip]="'DASHBOARD.COMPARE.VS_PREV' | translate"
                >
                  <i
                    class="pi text-[10px]"
                    [class.pi-arrow-up]="d.dir === 'up'"
                    [class.pi-arrow-down]="d.dir === 'down'"
                    [class.pi-minus]="d.dir === 'flat'"
                  ></i>
                  {{ d.pct | number: '1.0-1' }}%
                </span>
              }
            </div>
          </div>
          <div
            class="w-10 h-10 rounded-lg bg-emerald-50 dark:bg-emerald-900/30 flex items-center justify-center shrink-0 ml-3"
          >
            <i class="pi pi-wallet text-emerald-600 dark:text-emerald-400 text-lg"></i>
          </div>
        </div>
      </div>

      <!-- Expenses -->
      <div
        class="rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 p-3 sm:p-5 shadow-sm hover:shadow-md transition-shadow"
      >
        <div class="flex items-start justify-between">
          <div class="flex-1 min-w-0">
            <p
              class="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide"
            >
              {{ 'DASHBOARD.EXPENSES.TOTAL' | translate }}
            </p>
            <p class="text-lg sm:text-2xl font-bold text-red-600 mt-1 truncate tabular-nums">
              −{{ fmtM(stats().totalExpenses) }}
              <span class="text-sm font-normal text-gray-500">{{ currencySymbol() }}</span>
            </p>
            <div class="flex items-center gap-2 mt-1">
              <p class="text-xs text-gray-400 dark:text-gray-500">
                {{ 'DASHBOARD.EXPENSES.COUNT' | translate: { count: stats().expenseCount } }}
              </p>
              @if (expenseDelta(); as d) {
                <span
                  class="text-xs font-semibold inline-flex items-center gap-0.5"
                  [class.text-red-600]="d.dir === 'up'"
                  [class.text-emerald-600]="d.dir === 'down'"
                  [class.text-gray-400]="d.dir === 'flat'"
                  [pTooltip]="'DASHBOARD.COMPARE.VS_PREV' | translate"
                >
                  <i
                    class="pi text-[10px]"
                    [class.pi-arrow-up]="d.dir === 'up'"
                    [class.pi-arrow-down]="d.dir === 'down'"
                    [class.pi-minus]="d.dir === 'flat'"
                  ></i>
                  {{ d.pct | number: '1.0-1' }}%
                </span>
              }
            </div>
          </div>
          <div
            class="w-10 h-10 rounded-lg bg-red-50 dark:bg-red-900/30 flex items-center justify-center shrink-0 ml-3"
          >
            <i class="pi pi-arrow-circle-down text-red-600 dark:text-red-400 text-lg"></i>
          </div>
        </div>
      </div>

      <!-- Write-off loss -->
      <div
        class="rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 p-3 sm:p-5 shadow-sm hover:shadow-md transition-shadow"
      >
        <div class="flex items-start justify-between">
          <div class="flex-1 min-w-0">
            <p
              class="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide"
            >
              {{ 'DASHBOARD.EXPENSES.WRITE_OFF' | translate }}
            </p>
            <p class="text-lg sm:text-2xl font-bold text-amber-600 mt-1 truncate tabular-nums">
              −{{ fmtM(stats().writeOffLoss) }}
              <span class="text-sm font-normal text-gray-500">{{ currencySymbol() }}</span>
            </p>
            <p class="text-xs text-gray-400 dark:text-gray-500 mt-1">
              {{ 'DASHBOARD.EXPENSES.COUNT' | translate: { count: stats().writeOffCount } }}
            </p>
          </div>
          <div
            class="w-10 h-10 rounded-lg bg-amber-50 dark:bg-amber-900/30 flex items-center justify-center shrink-0 ml-3"
          >
            <i class="pi pi-trash text-amber-600 dark:text-amber-400 text-lg"></i>
          </div>
        </div>
      </div>

      <!-- Formula recap -->
      <div
        class="rounded-xl border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800/50 p-3 sm:p-5 shadow-sm flex flex-col justify-center gap-1.5"
      >
        <div class="flex items-center justify-between text-sm">
          <span class="text-gray-500 dark:text-gray-400">{{
            'DASHBOARD.KPI.GROSS_PROFIT' | translate
          }}</span>
          <span class="font-semibold text-gray-800 dark:text-gray-200 tabular-nums">{{
            fmtM(stats().totalProfit)
          }}</span>
        </div>
        <div class="flex items-center justify-between text-sm">
          <span class="text-gray-500 dark:text-gray-400"
            >− {{ 'DASHBOARD.EXPENSES.TOTAL' | translate }}</span
          >
          <span class="font-semibold text-red-600 tabular-nums">{{
            fmtM(stats().totalExpenses)
          }}</span>
        </div>
        <div class="flex items-center justify-between text-sm">
          <span class="text-gray-500 dark:text-gray-400"
            >− {{ 'DASHBOARD.EXPENSES.WRITE_OFF' | translate }}</span
          >
          <span class="font-semibold text-amber-600 tabular-nums">{{
            fmtM(stats().writeOffLoss)
          }}</span>
        </div>
        <div
          class="border-t border-gray-200 dark:border-gray-700 mt-1 pt-1.5 flex items-center justify-between text-sm"
        >
          <span class="font-semibold text-gray-700 dark:text-gray-300"
            >= {{ 'DASHBOARD.KPI.NET_PROFIT' | translate }}</span
          >
          <span
            class="font-bold tabular-nums"
            [class.text-emerald-600]="stats().netProfit >= 0"
            [class.text-red-600]="stats().netProfit < 0"
            >{{ fmtM(stats().netProfit) }}</span
          >
        </div>
      </div>
    </div>
  }

  <!-- ── Today summary strip ── -->
  @if (!loading() && (stats().todaySales > 0 || stats().totalOutstandingDebt > 0)) {
    <div class="grid gap-3 grid-cols-1 sm:grid-cols-3">
      <div
        class="rounded-lg border border-green-100 dark:border-green-900/40 bg-green-50 dark:bg-green-900/20 px-4 py-3 flex items-center gap-3"
      >
        <i class="pi pi-sun text-green-500 text-xl"></i>
        <div>
          <p class="text-xs text-green-600 dark:text-green-300 font-medium">
            {{ 'DASHBOARD.STRIP.TODAY_SALES' | translate }}
          </p>
          <p class="text-base font-bold text-green-700 dark:text-green-200">
            {{ fmtM(stats().todaySales) }} {{ currencySymbol() }}
          </p>
        </div>
      </div>
      <div
        class="rounded-lg border border-emerald-100 dark:border-emerald-900/40 bg-emerald-50 dark:bg-emerald-900/20 px-4 py-3 flex items-center gap-3"
      >
        <i class="pi pi-box text-emerald-500 text-xl"></i>
        <div>
          <p class="text-xs text-emerald-600 dark:text-emerald-300 font-medium">
            {{ 'DASHBOARD.STRIP.ACTIVE_PRODUCTS' | translate }}
          </p>
          <p class="text-base font-bold text-emerald-700 dark:text-emerald-200">
            {{ fmt(stats().activeProducts) }}
          </p>
        </div>
      </div>
      <div
        class="rounded-lg border border-amber-100 dark:border-amber-900/40 bg-amber-50 dark:bg-amber-900/20 px-4 py-3 flex items-center gap-3"
      >
        <i class="pi pi-credit-card text-amber-500 text-xl"></i>
        <div>
          <p class="text-xs text-amber-600 dark:text-amber-300 font-medium">
            {{ 'DASHBOARD.STRIP.TOTAL_DEBT' | translate }}
          </p>
          <p class="text-base font-bold text-amber-700 dark:text-amber-200">
            {{ fmtM(stats().totalOutstandingDebt) }} {{ currencySymbol() }}
          </p>
        </div>
      </div>
    </div>
  }

  <!-- ── Charts Row 1: Weekly + Revenue/Profit Trend ── -->
  <div class="grid gap-4 lg:grid-cols-2">
    <!-- Weekly Bar Chart -->
    <div
      class="rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 shadow-sm"
    >
      <div class="px-5 pt-5 pb-3">
        <h3 class="font-semibold text-gray-900 dark:text-gray-100">
          {{ 'DASHBOARD.CHARTS.WEEKLY' | translate }}
        </h3>
        <p class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
          {{ 'DASHBOARD.CHARTS.WEEKLY_SUB' | translate }}
        </p>
      </div>
      <div class="px-5 pb-5">
        @if (loading()) {
          <p-skeleton height="240px" />
        } @else if (statStatus() === 'forbidden') {
          <ng-container [ngTemplateOutlet]="forbiddenTpl" />
        } @else if (statStatus() === 'error') {
          <ng-container [ngTemplateOutlet]="errorTpl" />
        } @else if (stats().weeklyChart.length === 0) {
          <div
            class="h-60 flex flex-col items-center justify-center text-gray-400 dark:text-gray-600 gap-2"
          >
            <i class="pi pi-chart-bar text-4xl"></i>
            <p class="text-sm">{{ 'DASHBOARD.CHARTS.EMPTY' | translate }}</p>
          </div>
        } @else {
          <div class="h-40 sm:h-60">
            <p-chart type="bar" [data]="weeklyChartData()" [options]="weeklyChartOptions" />
          </div>
        }
      </div>
    </div>

    <!-- Revenue + Profit Trend Line -->
    <div
      class="rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 shadow-sm"
    >
      <div class="px-5 pt-5 pb-3">
        <h3 class="font-semibold text-gray-900 dark:text-gray-100">
          {{ 'DASHBOARD.CHARTS.TREND' | translate }}
        </h3>
        <p class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
          {{ 'DASHBOARD.CHARTS.TREND_SUB' | translate }}
        </p>
      </div>
      <div class="px-5 pb-5">
        @if (loading()) {
          <p-skeleton height="240px" />
        } @else if (trendStatus() === 'forbidden') {
          <ng-container [ngTemplateOutlet]="forbiddenTpl" />
        } @else if (trendStatus() === 'error') {
          <ng-container [ngTemplateOutlet]="errorTpl" />
        } @else if (trend().length === 0) {
          <div
            class="h-60 flex flex-col items-center justify-center text-gray-400 dark:text-gray-600 gap-2"
          >
            <i class="pi pi-chart-line text-4xl"></i>
            <p class="text-sm">{{ 'DASHBOARD.CHARTS.EMPTY' | translate }}</p>
          </div>
        } @else {
          <div class="h-40 sm:h-60">
            <p-chart type="line" [data]="trendChartData()" [options]="trendChartOptions" />
          </div>
        }
      </div>
    </div>
  </div>

  <!-- ── Charts Row 2: Top Products + Category Donut ── -->
  <div class="grid gap-4 lg:grid-cols-3">
    <div
      class="lg:col-span-2 rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 shadow-sm"
    >
      <div class="px-5 pt-5 pb-3">
        <h3 class="font-semibold text-gray-900 dark:text-gray-100">
          {{ 'DASHBOARD.CHARTS.TOP_PRODUCTS' | translate }}
        </h3>
        <p class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
          {{ 'DASHBOARD.CHARTS.TOP_PRODUCTS_SUB' | translate }}
        </p>
      </div>
      <div class="px-5 pb-5">
        @if (loading()) {
          <p-skeleton height="240px" />
        } @else if (statStatus() === 'forbidden') {
          <ng-container [ngTemplateOutlet]="forbiddenTpl" />
        } @else if (statStatus() === 'error') {
          <ng-container [ngTemplateOutlet]="errorTpl" />
        } @else if (stats().topProducts.length === 0) {
          <div
            class="h-60 flex flex-col items-center justify-center text-gray-400 dark:text-gray-600 gap-2"
          >
            <i class="pi pi-box text-4xl"></i>
            <p class="text-sm">{{ 'DASHBOARD.CHARTS.EMPTY' | translate }}</p>
          </div>
        } @else {
          <div class="h-52 sm:h-60">
            <p-chart
              type="bar"
              [data]="topProductsChartData()"
              [options]="topProductsChartOptions"
            />
          </div>
        }
      </div>
    </div>

    <div
      class="rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 shadow-sm"
    >
      <div class="px-5 pt-5 pb-3">
        <h3 class="font-semibold text-gray-900 dark:text-gray-100">
          {{ 'DASHBOARD.CHARTS.CATEGORIES' | translate }}
        </h3>
        <p class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
          {{ 'DASHBOARD.CHARTS.CATEGORIES_SUB' | translate }}
        </p>
      </div>
      <div class="px-5 pb-5">
        @if (loading()) {
          <p-skeleton height="240px" />
        } @else if (catStatus() === 'forbidden') {
          <ng-container [ngTemplateOutlet]="forbiddenTpl" />
        } @else if (catStatus() === 'error') {
          <ng-container [ngTemplateOutlet]="errorTpl" />
        } @else if (cats().length === 0) {
          <div
            class="h-60 flex flex-col items-center justify-center text-gray-400 dark:text-gray-600 gap-2"
          >
            <i class="pi pi-chart-pie text-4xl"></i>
            <p class="text-sm">{{ 'DASHBOARD.CHARTS.EMPTY' | translate }}</p>
          </div>
        } @else {
          <div class="h-44 sm:h-60">
            <p-chart
              type="doughnut"
              [data]="categoryChartData()"
              [options]="categoryChartOptions"
            />
          </div>
        }
      </div>
    </div>
  </div>

  <!-- ── Charts Row 3: Payment breakdown + Peak hours ── -->
  <div class="grid gap-4 lg:grid-cols-3">
    <div
      class="rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 shadow-sm"
    >
      <div class="px-5 pt-5 pb-3">
        <h3 class="font-semibold text-gray-900 dark:text-gray-100">
          {{ 'DASHBOARD.CHARTS.PAYMENT' | translate }}
        </h3>
        <p class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
          {{ 'DASHBOARD.CHARTS.PAYMENT_SUB' | translate }}
        </p>
      </div>
      <div class="px-5 pb-5">
        @if (loading()) {
          <p-skeleton height="240px" />
        } @else if (statStatus() === 'forbidden') {
          <ng-container [ngTemplateOutlet]="forbiddenTpl" />
        } @else if (statStatus() === 'error') {
          <ng-container [ngTemplateOutlet]="errorTpl" />
        } @else if (stats().paymentBreakdown.length === 0) {
          <div
            class="h-60 flex flex-col items-center justify-center text-gray-400 dark:text-gray-600 gap-2"
          >
            <i class="pi pi-wallet text-4xl"></i>
            <p class="text-sm">{{ 'DASHBOARD.CHARTS.EMPTY' | translate }}</p>
          </div>
        } @else {
          <div class="h-44 sm:h-60">
            <p-chart type="doughnut" [data]="paymentChartData()" [options]="paymentChartOptions" />
          </div>
        }
      </div>
    </div>

    <div
      class="lg:col-span-2 rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 shadow-sm"
    >
      <div class="px-5 pt-5 pb-3">
        <h3 class="font-semibold text-gray-900 dark:text-gray-100">
          {{ 'DASHBOARD.CHARTS.PEAK_HOURS' | translate }}
        </h3>
        <p class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
          {{ 'DASHBOARD.CHARTS.PEAK_HOURS_SUB' | translate }}
        </p>
      </div>
      <div class="px-5 pb-5">
        @if (loading()) {
          <p-skeleton height="240px" />
        } @else if (statStatus() === 'forbidden') {
          <ng-container [ngTemplateOutlet]="forbiddenTpl" />
        } @else if (statStatus() === 'error') {
          <ng-container [ngTemplateOutlet]="errorTpl" />
        } @else if (stats().hourlySales.length === 0) {
          <div
            class="h-60 flex flex-col items-center justify-center text-gray-400 dark:text-gray-600 gap-2"
          >
            <i class="pi pi-clock text-4xl"></i>
            <p class="text-sm">{{ 'DASHBOARD.CHARTS.EMPTY' | translate }}</p>
          </div>
        } @else {
          <div class="h-40 sm:h-60">
            <p-chart type="bar" [data]="hourlyChartData()" [options]="hourlyChartOptions" />
          </div>
        }
      </div>
    </div>
  </div>

  <!-- ── Bottom Row: Category table + Recent Orders ── -->
  <div class="grid gap-4 lg:grid-cols-2">
    <div
      class="rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 shadow-sm overflow-hidden"
    >
      <div class="px-5 pt-5 pb-3">
        <h3 class="font-semibold text-gray-900 dark:text-gray-100">
          {{ 'DASHBOARD.CATEGORY_REPORT.TITLE' | translate }}
        </h3>
        <p class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
          {{ 'DASHBOARD.CATEGORY_REPORT.SUBTITLE' | translate }}
        </p>
      </div>
      @if (loading()) {
        <div class="px-5 pb-5 space-y-3">
          @for (_ of [1, 2, 3, 4]; track $index) {
            <p-skeleton height="2.5rem" />
          }
        </div>
      } @else if (catStatus() === 'forbidden') {
        <div class="px-5 pb-6"><ng-container [ngTemplateOutlet]="forbiddenTpl" /></div>
      } @else if (catStatus() === 'error') {
        <div class="px-5 pb-6"><ng-container [ngTemplateOutlet]="errorTpl" /></div>
      } @else if (cats().length === 0) {
        <div
          class="px-5 pb-8 flex flex-col items-center justify-center text-gray-400 dark:text-gray-600 gap-2"
        >
          <i class="pi pi-tag text-3xl"></i>
          <p class="text-sm">{{ 'DASHBOARD.CHARTS.EMPTY' | translate }}</p>
        </div>
      } @else {
        <div class="divide-y divide-gray-100 dark:divide-gray-800 max-h-[700px] overflow-y-auto">
          @for (cat of cats(); track cat.categoryId) {
            <div class="px-5 py-3">
              <div class="flex items-center justify-between mb-1.5">
                <span class="text-sm font-medium text-gray-800 dark:text-gray-200 truncate">{{
                  cat.categoryName
                }}</span>
                <div class="flex items-center gap-3 ml-2 shrink-0">
                  <span class="text-xs text-gray-500"
                    >{{ cat.itemsSold }} {{ 'COMMON.PIECES_SHORT' | translate }}</span
                  >
                  <span class="text-sm font-semibold text-gray-900 dark:text-gray-100">{{
                    fmtM(cat.revenue)
                  }}</span>
                  <span
                    class="text-xs font-medium text-green-600 dark:text-green-400 w-10 text-right"
                    >{{ cat.percentage | number: '1.1-1' }}%</span
                  >
                </div>
              </div>
              <p-progressbar [value]="cat.percentage" [showValue]="false" styleClass="h-1.5" />
            </div>
          }
        </div>
      }
    </div>

    <div
      class="rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 shadow-sm overflow-hidden"
    >
      <div class="px-5 pt-5 pb-3">
        <h3 class="font-semibold text-gray-900 dark:text-gray-100">
          {{ 'DASHBOARD.RECENT_ORDERS.TITLE' | translate }}
        </h3>
        <p class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
          {{ 'DASHBOARD.RECENT_ORDERS.SUBTITLE' | translate }}
        </p>
      </div>
      @if (loading()) {
        <div class="px-5 pb-5 space-y-3">
          @for (_ of [1, 2, 3, 4, 5]; track $index) {
            <p-skeleton height="3rem" />
          }
        </div>
      } @else if (orderStatus() === 'forbidden') {
        <div class="px-5 pb-6"><ng-container [ngTemplateOutlet]="forbiddenTpl" /></div>
      } @else if (orderStatus() === 'error') {
        <div class="px-5 pb-6"><ng-container [ngTemplateOutlet]="errorTpl" /></div>
      } @else if (orders().length === 0) {
        <div
          class="px-5 pb-8 flex flex-col items-center justify-center text-gray-400 dark:text-gray-600 gap-2"
        >
          <i class="pi pi-shopping-bag text-3xl"></i>
          <p class="text-sm">{{ 'DASHBOARD.RECENT_ORDERS.EMPTY' | translate }}</p>
        </div>
      } @else {
        <div class="divide-y divide-gray-100 dark:divide-gray-800">
          @for (order of orders(); track order.id) {
            <div class="px-5 py-3 flex items-center gap-3">
              <div class="flex-1 min-w-0">
                <div class="flex items-center gap-2">
                  <span class="text-xs font-mono text-gray-500 dark:text-gray-400"
                    >#{{ order.receiptNumber }}</span
                  >
                  <p-tag
                    [value]="getOrderLabel(order.status)"
                    [severity]="getOrderSeverity(order.status)"
                    styleClass="text-xs px-1.5 py-0.5"
                  />
                </div>
                <div class="flex items-center gap-2 mt-0.5">
                  <span class="text-xs text-gray-500 dark:text-gray-400 truncate">{{
                    order.storeName
                  }}</span>
                  <span class="text-gray-300 dark:text-gray-600">·</span>
                  <span class="text-xs text-gray-400 dark:text-gray-500">{{
                    formatDate(order.orderDate)
                  }}</span>
                </div>
              </div>
              <div class="text-right shrink-0">
                <p class="text-sm font-semibold text-gray-900 dark:text-gray-100">
                  {{ fmtM(order.totalAmount) }}
                </p>
                <p class="text-xs text-gray-400 dark:text-gray-500">
                  {{ getPaymentLabel(order.paymentType) }}
                </p>
              </div>
            </div>
          }
        </div>
      }
    </div>
  </div>

  <!-- ── Bottom Row 2: Cashier performance + Top debtors ── -->
  <div class="grid gap-4 lg:grid-cols-2">
    <div
      class="rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 shadow-sm overflow-hidden"
    >
      <div class="px-5 pt-5 pb-3">
        <h3 class="font-semibold text-gray-900 dark:text-gray-100">
          {{ 'DASHBOARD.CASHIERS.TITLE' | translate }}
        </h3>
        <p class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
          {{ 'DASHBOARD.CASHIERS.SUBTITLE' | translate }}
        </p>
      </div>
      @if (loading()) {
        <div class="px-5 pb-5 space-y-3">
          @for (_ of [1, 2, 3]; track $index) {
            <p-skeleton height="2.5rem" />
          }
        </div>
      } @else if (statStatus() === 'forbidden') {
        <div class="px-5 pb-6"><ng-container [ngTemplateOutlet]="forbiddenTpl" /></div>
      } @else if (statStatus() === 'error') {
        <div class="px-5 pb-6"><ng-container [ngTemplateOutlet]="errorTpl" /></div>
      } @else if (stats().cashierPerformance.length === 0) {
        <div
          class="px-5 pb-8 flex flex-col items-center justify-center text-gray-400 dark:text-gray-600 gap-2"
        >
          <i class="pi pi-users text-3xl"></i>
          <p class="text-sm">{{ 'DASHBOARD.CASHIERS.EMPTY' | translate }}</p>
        </div>
      } @else {
        <div class="divide-y divide-gray-100 dark:divide-gray-800">
          @for (c of stats().cashierPerformance; track c.name; let i = $index) {
            <div class="px-5 py-3 flex items-center gap-3">
              <span
                class="w-6 h-6 rounded-full bg-green-50 dark:bg-green-900/30 text-green-600 dark:text-green-400 text-xs font-bold flex items-center justify-center shrink-0"
                >{{ i + 1 }}</span
              >
              <div class="flex-1 min-w-0">
                <p class="text-sm font-medium text-gray-800 dark:text-gray-200 truncate">
                  {{ c.name }}
                </p>
                <p class="text-xs text-gray-500 dark:text-gray-400">
                  {{ 'DASHBOARD.KPI.ORDERS' | translate }}: {{ fmt(c.orders) }}
                </p>
              </div>
              <span class="text-sm font-semibold text-gray-900 dark:text-gray-100 shrink-0">{{
                fmtM(c.sales)
              }}</span>
            </div>
          }
        </div>
      }
    </div>

    <div
      class="rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 shadow-sm overflow-hidden"
    >
      <div class="px-5 pt-5 pb-3">
        <h3 class="font-semibold text-gray-900 dark:text-gray-100">
          {{ 'DASHBOARD.DEBTORS.TITLE' | translate }}
        </h3>
        <p class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
          {{ 'DASHBOARD.DEBTORS.SUBTITLE' | translate }}
        </p>
      </div>
      @if (loading()) {
        <div class="px-5 pb-5 space-y-3">
          @for (_ of [1, 2, 3]; track $index) {
            <p-skeleton height="2.5rem" />
          }
        </div>
      } @else if (statStatus() === 'forbidden') {
        <div class="px-5 pb-6"><ng-container [ngTemplateOutlet]="forbiddenTpl" /></div>
      } @else if (statStatus() === 'error') {
        <div class="px-5 pb-6"><ng-container [ngTemplateOutlet]="errorTpl" /></div>
      } @else if (stats().topDebtors.length === 0) {
        <div
          class="px-5 pb-8 flex flex-col items-center justify-center text-gray-400 dark:text-gray-600 gap-2"
        >
          <i class="pi pi-check-circle text-3xl"></i>
          <p class="text-sm">{{ 'DASHBOARD.DEBTORS.EMPTY' | translate }}</p>
        </div>
      } @else {
        <div class="divide-y divide-gray-100 dark:divide-gray-800">
          @for (d of stats().topDebtors; track $index) {
            <div class="px-5 py-3 flex items-center gap-3">
              <i class="pi pi-user text-amber-500 shrink-0"></i>
              <div class="flex-1 min-w-0">
                <p class="text-sm font-medium text-gray-800 dark:text-gray-200 truncate">
                  {{ d.name }}
                </p>
                <p class="text-xs text-gray-500 dark:text-gray-400">
                  {{ d.phone || '—' }} · {{ d.orderCount }} {{ 'COMMON.PIECES_SHORT' | translate }}
                </p>
              </div>
              <span class="text-sm font-semibold text-amber-600 dark:text-amber-400 shrink-0">{{
                fmtM(d.amount)
              }}</span>
            </div>
          }
        </div>
      }
    </div>
  </div>

  <!-- ── Low Stock Alerts ── -->
  <!--
    Zararga sotilayotgan mahsulotlar. Bu odatda aksiya emas, narx kiritishdagi
    xato: bitta shunday mahsulot butun oylik foydani minusga tortishi mumkin va
    umumiy raqam ichida ko'rinmay qoladi. Shuning uchun alohida, qizil blokda.
  -->
  @if (!loading() && statStatus() === 'ok' && stats().belowCostAlerts.length > 0) {
    <div
      class="rounded-xl border border-red-200 dark:border-red-800/50 bg-red-50 dark:bg-red-900/20 shadow-sm overflow-hidden"
    >
      <div class="px-5 pt-4 pb-1 flex items-center gap-2">
        <i class="pi pi-times-circle text-red-500 text-lg"></i>
        <h3 class="font-semibold text-red-800 dark:text-red-300">
          {{ 'DASHBOARD.BELOW_COST.TITLE' | translate }}
        </h3>
        <span
          class="ml-auto text-xs bg-red-200 dark:bg-red-800 text-red-800 dark:text-red-200 px-2 py-0.5 rounded-full font-medium"
        >
          {{ 'DASHBOARD.LOW_STOCK.COUNT' | translate: { count: stats().belowCostAlerts.length } }}
        </span>
      </div>
      <p class="px-5 pb-3 text-xs text-red-700/80 dark:text-red-400/80">
        {{ 'DASHBOARD.BELOW_COST.HINT' | translate }}
      </p>
      <div class="grid sm:grid-cols-2 lg:grid-cols-3 gap-2 px-5 pb-4">
        @for (item of stats().belowCostAlerts; track $index) {
          <div
            class="bg-white dark:bg-gray-900 rounded-lg px-3 py-2 border border-red-100 dark:border-red-800/30"
          >
            <p class="truncate text-sm font-medium">{{ item.productName }}</p>
            <div class="flex items-baseline justify-between gap-2 mt-1 text-xs tabular-nums">
              <span class="text-gray-500 dark:text-gray-400">
                {{ item.sellPrice | money: stats().currency }} &lt;
                {{ item.cost | money: stats().currency }}
              </span>
              <span class="font-semibold text-red-600 dark:text-red-400 shrink-0">
                −{{ item.lossPerUnit | money: stats().currency }}
              </span>
            </div>
          </div>
        }
      </div>
    </div>
  }

  @if (!loading() && statStatus() === 'ok' && stats().lowStockAlerts.length > 0) {
    <div
      class="rounded-xl border border-amber-200 dark:border-amber-800/50 bg-amber-50 dark:bg-amber-900/20 shadow-sm overflow-hidden"
    >
      <div class="px-5 pt-4 pb-3 flex items-center gap-2">
        <i class="pi pi-exclamation-triangle text-amber-500 text-lg"></i>
        <h3 class="font-semibold text-amber-800 dark:text-amber-300">
          {{ 'DASHBOARD.LOW_STOCK.TITLE' | translate }}
        </h3>
        <span
          class="ml-auto text-xs bg-amber-200 dark:bg-amber-800 text-amber-800 dark:text-amber-200 px-2 py-0.5 rounded-full font-medium"
        >
          {{ 'DASHBOARD.LOW_STOCK.COUNT' | translate: { count: stats().lowStockAlerts.length } }}
        </span>
      </div>
      <div class="grid sm:grid-cols-2 lg:grid-cols-3 gap-2 px-5 pb-4">
        @for (item of stats().lowStockAlerts; track $index) {
          <div
            class="flex items-center justify-between bg-white dark:bg-gray-900 rounded-lg px-3 py-2 border border-amber-100 dark:border-amber-800/30"
          >
            <div class="min-w-0 max-w-[200px]">
              <p class="truncate text-sm font-medium">
                {{ item.productName }}
              </p>
              <p class="text-xs text-gray-500 dark:text-gray-400">{{ item.storeName }}</p>
            </div>
            <p-tag
              [value]="item.quantity + ' ' + ('COMMON.PIECES_SHORT' | translate)"
              [severity]="getLowStockSeverity(item.quantity)"
              styleClass="ml-2 shrink-0"
            />
          </div>
        }
      </div>
    </div>
  }
</div>

<!-- ── Reusable state templates ── -->
<ng-template #forbiddenTpl>
  <div
    class="h-60 flex flex-col items-center justify-center text-gray-400 dark:text-gray-600 gap-2 text-center px-4"
  >
    <i class="pi pi-lock text-4xl"></i>
    <p class="text-sm">{{ 'DASHBOARD.STATE.FORBIDDEN' | translate }}</p>
  </div>
</ng-template>

<ng-template #errorTpl>
  <div
    class="h-60 flex flex-col items-center justify-center text-gray-400 dark:text-gray-600 gap-3 text-center px-4"
  >
    <i class="pi pi-exclamation-circle text-4xl text-red-400"></i>
    <p class="text-sm">{{ 'DASHBOARD.STATE.ERROR' | translate }}</p>
    <p-button
      [label]="'DASHBOARD.STATE.RETRY' | translate"
      icon="pi pi-refresh"
      severity="secondary"
      [outlined]="true"
      size="small"
      (onClick)="loadData()"
    />
  </div>
</ng-template>
